import React, { useEffect, useRef, useState } from 'react';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { DataProviderInstance } from '../../../../../api/DataProvider';
import styles from './InsuranceProcedures.module.css';

const SEARCH_DELAY_MS = 300;

/**
 * Busca no catálogo TUSS (tabela 22 da ANS) por código ou por palavras do nome.
 * Escolher um item só preenche o formulário: código e nome continuam editáveis.
 */
function TussSearchField({ disabled, onPick }) {
    const { SearchTussProcedures } = DataProviderInstance();
    const [input, setInput] = useState('');
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const requestRef = useRef(0);

    useEffect(() => {
        const query = input.trim();
        if (query.length < 2) {
            setOptions([]);
            setLoading(false);
            return undefined;
        }
        setLoading(true);
        const requestId = ++requestRef.current;
        const timer = setTimeout(() => {
            SearchTussProcedures(query, (result) => {
                if (requestId !== requestRef.current) return;
                setOptions(result?.status === 'SUCCESS' && Array.isArray(result.data) ? result.data : []);
                setLoading(false);
            });
        }, SEARCH_DELAY_MS);
        return () => clearTimeout(timer);
    }, [input, SearchTussProcedures]);

    return (
        <Autocomplete
            options={options}
            filterOptions={(list) => list}
            getOptionLabel={(option) => `${option.code} · ${option.name}`}
            isOptionEqualToValue={(option, value) => option.code === value.code}
            value={null}
            inputValue={input}
            onInputChange={(e, value, reason) => { if (reason !== 'reset') setInput(value); }}
            onChange={(e, option) => {
                if (option) {
                    onPick(option);
                    setInput('');
                    setOptions([]);
                }
            }}
            loading={loading}
            loadingText="Buscando..."
            noOptionsText={input.trim().length < 2 ? 'Digite o código ou o nome' : 'Nada encontrado na TUSS'}
            disabled={disabled}
            size="small"
            className={styles.input}
            renderOption={(props, option) => (
                <li {...props} key={option.code} className={`${props.className || ''} ${styles.tussOption}`}>
                    <span className={styles.code}>{option.code}</span>
                    <span className={styles.tussName}>{option.name}</span>
                </li>
            )}
            renderInput={(params) => (
                <TextField
                    {...params}
                    placeholder="Ex.: 10101012 ou consulta em consultório"
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading ? <CircularProgress size={16} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                        )
                    }}
                    inputProps={{ ...params.inputProps, 'aria-label': 'Buscar na TUSS' }}
                />
            )}
        />
    );
}

export default TussSearchField;
